
import axios, { AxiosRequestConfig } from "axios";
import AppConfig from "../config/AppConfig";

export const axiosConfig: AxiosRequestConfig = {
    baseURL: AppConfig().BaseUrl,
    headers: {
        'Authorization': AppConfig().ApiKey!
    },
    responseType: "json"
}

export default axios.create(axiosConfig);
